import React from "react";
import AnnouncementForm from "./AnnouncementForm";
import TabLayout from "../../../../helpers/TabLayout";
import {
  announcementCreate,
  announcementUpdateLongDescription,
} from "../../../../../api/announcement";

const announcementCreateAction = async ({ request }) => {
  const formData = await request.formData();

  const submission = {
    label: formData.get("label"),
    userEntityId: formData.get("userEntityId"),
  };

  const res = await announcementCreate({ ...submission });
  if (res.code === "SUCCESS") {
    const longDescription = formData.get("longDescription");
    await announcementUpdateLongDescription(res.data.announcementEntityId,
      longDescription);
  }
  return res;
};

const AnnouncementCreateForm = () => (
  <TabLayout headerLabel="Create New Announcement">
    <AnnouncementForm image={null}/>
  </TabLayout>
);

export { announcementCreateAction };
export default AnnouncementCreateForm;